import _get from 'lodash/get';
import _find from 'lodash/find';
import { chatSelectors } from '@lifesize/nucleus';
import { createSelector } from 'reselect';

const nucleusUnreadCount = state =>
  chatSelectors.groupedConversationsWithUnread(state).totalUnreadMessageCount;
const appUnreadCount = state => _get(state, 'app.chat.unreadChatCount');

export const hasUnreadChats = createSelector(
  nucleusUnreadCount,
  appUnreadCount,
  (nucleusUnread, appUnread) => (nucleusUnread <= 99 && nucleusUnread !== appUnread)
);

const convDialString = state => _get(state, 'app.chat.selectedConversationContactDialString');
const convMode = state => _get(state, 'app.chat.conversationMode');

export function getNewConversationContactDialString(conversation) {
  if (conversation) {
    return conversation.contact.dialString;
  }
  return undefined;
}

export const currentConversationDialStringSelector = createSelector(
  convDialString,
  convMode,
  chatSelectors.groupedConversations,
  (conversationContactDialString, conversationMode, conversations) => {
    let selectedConversationContactDialString = conversationContactDialString;
    const meetingConversations = conversations.meetingConversations || [];
    const userConversations = conversations.userConversations || [];

    /* if you are re-opening the app and your local storage has been cleared (or the stored
     * contactId oes not belong to one of your chat contacts), automatically select the first
     * p2p or meeting contact. If there are no contacts in either list, Chat
     * will load as isFirstUse */
    if (conversationMode === 'new') {
      const allConversations = [...userConversations, ...meetingConversations];

      if (!_find(allConversations, { contact: { dialString: conversationContactDialString } })) {
        selectedConversationContactDialString =
          getNewConversationContactDialString(allConversations.shift());
      }
    }

    return selectedConversationContactDialString;
  }
);
